import { Middleware } from '@reduxjs/toolkit';

import { fetchUserData, resetAuth } from '../auth.slice';

export const authMiddleware: Middleware = (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type === 'auth/setIsAuthenticated' && action.payload === true) {
        store.dispatch(fetchUserData() as any);
    }

    if (action.type === 'auth/setIsAuthenticated' && action.payload === false) {
        store.dispatch(resetAuth() as any);
    }

    return result;
};
